// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-options-item .fi-options-item-wrapper {
  color: var(--fi-color-dark);
  background-color: var(--fi-background-color-light);
}
.fi-options-item .fi-options-item-wrapper.selected {
  color: var(--fi-color-white);
  background-color: var(--branded-background-color);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-options/fi-options-item.component.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;EACA,kDAAA;AAAR;AAEQ;EACI,4BAAA;EACA,iDAAA;AAAZ","sourcesContent":[".fi-options-item {\r\n    .fi-options-item-wrapper {\r\n        color: var(--fi-color-dark);\r\n        background-color: var(--fi-background-color-light);\r\n\r\n        &.selected {\r\n            color: var(--fi-color-white);\r\n            background-color: var(--branded-background-color);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
